import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import { updateBedSoreFour } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TBedScoreFourDefaultValues,
} from 'routes/Main/Survey/type';

import CommonPatientInfo from '../components/CommonPatientInfo';
import BedScoreFourContents from './BedScoreFourContents';

const BedScoreFour = (props: SurveyDialogProps<TBedScoreFourDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    patientInfo,
    nurseName,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, watch, register, getValues, setValue } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TBedScoreFourDefaultValues) => {
    const { patient_id } = patientInfo;
    const {
      gender,
      age,
      weight,
      incontinence,
      mobility,
      appetite,

      skin00,
      skin01,
      skin02,
      skin03,
      skin04,
      skin05,

      special_risk00,
      special_risk01,
      special_risk02,
      special_risk03,
      special_risk04,
      special_risk05,
      special_risk06,
      special_risk07,
      special_risk08,
      special_risk09,
      special_risk010,
      special_risk011,
      special_risk012,
      special_risk013,
      special_risk014,
    } = data;

    const request = {
      user_id,
      patient_id: patient_id,
      bedsore4_survey: {
        gender,
        age,
        weight,
        incontinence,
        mobility,
        appetite,

        skin00: JSON.stringify(skin00),
        skin01: JSON.stringify(skin01),
        skin02: JSON.stringify(skin02),
        skin03: JSON.stringify(skin03),
        skin04: JSON.stringify(skin04),
        skin05: JSON.stringify(skin05),

        special_risk00: JSON.stringify(special_risk00),
        special_risk01: JSON.stringify(special_risk01),
        special_risk02: JSON.stringify(special_risk02),
        special_risk03: JSON.stringify(special_risk03),
        special_risk04: JSON.stringify(special_risk04),
        special_risk05: JSON.stringify(special_risk05),
        special_risk06: JSON.stringify(special_risk06),
        special_risk07: JSON.stringify(special_risk07),
        special_risk08: JSON.stringify(special_risk08),
        special_risk09: JSON.stringify(special_risk09),
        special_risk010: JSON.stringify(special_risk010),
        special_risk011: JSON.stringify(special_risk011),
        special_risk012: JSON.stringify(special_risk012),
        special_risk013: JSON.stringify(special_risk013),
        special_risk014: JSON.stringify(special_risk014),
      },
    };

    updateBedSoreFour(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          욕창위험 평가도구 4
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <BedScoreFourContents {...formProps} />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default BedScoreFour;
